import { connect } from 'react-redux'
import { PhoneLineComponent } from './PhoneLine'
import showCasesCreateTroubleTicket from 'features/Cases/CasesCreateTroubleTicket'
import showNumbersDisconnectModal from 'features/Numbers/NumbersDisconnectModal'

const stateToProps = () => ({})

export const dispatchToProps = {
  showCasesCreateTroubleTicket,
  showNumbersDisconnectModal,
}

export const PhoneLine = connect(stateToProps, dispatchToProps)(PhoneLineComponent)



// WEBPACK FOOTER //
// src/pages/PhoneLine/PhoneLine.container.ts